import React, { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { apiService } from '../../services/apiService';

function GeneralCaseCats({onReload}) {
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;
    const parts_location = location.pathname.split("/");
    // const caseSlug = parts_location[2] || null;
    const caseId = parts_location[4] || null;
    const [sideBarList, setSideBarList] = useState([]);
    const [loading, setLoading] = useState(true);
    const fetchFormData = useCallback(async () => {
        setLoading(true);
        try {
            const param = {
                case_id : caseId
            }
            const response = await apiService.postRequest(`/general-case/sidebar`, param);
            if (response && response.success === true) {
                setSideBarList(response.data)
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, [caseId]);
    
    useEffect(() => {
        fetchFormData();
    }, [fetchFormData, onReload]);
  return (
    <div className='validate_dragers borfirster'>
        {loading ?
        <div className='d-flex justify-content-center w-100'>
            <img style={{ width: "100px" }} src={require('../../../src/assets/pinkloader.gif')} alt='Loading...' />
        </div> : <>
            {sideBarList && sideBarList.map((sideDataMain, index) => (
                <div key={index} className='d-flex flex-column border_catsvalidate'>
                    <h5>{sideDataMain.stage}</h5>

                    {sideDataMain && sideDataMain?.sub_stage.map((sideData, indexs) => (
                    <span className={currentPath.startsWith(sideData.stage_link) ? "span_greenonbact" : sideData.status === "skipped" ? "skippend_strike span_disabledrager" :
                            sideData.permission !== true ? "span_disabledrager" : ""
                        } key={indexs} onClick={()=> { 
                        if(sideData && sideData.permission === true){
                            navigate(sideData.stage_link)
                        }
                    }}>
                        {sideData && sideData.status === "in-progress" ? 
                        <img src={require('../../assets/circleprocess.svg').default} alt=""/>:
                        sideData.status === "completed" ?
                        <img src={require('../../assets/circlecheck.svg').default} alt=""/>:
                        sideData.status === "rejected" ?
                        <img src={require('../../assets/circleclose.svg').default} alt=""/>:
                        <img src={require('../../assets/circlelock.svg').default} alt=""/>
                    }
                        {sideData.stage}</span>
                    ))}
                </div>
            ))}
        </>}
    </div>
  )
}

export default GeneralCaseCats
